const money_off = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33311)">
      <path d="M12.4996 6.9C14.2796 6.9 14.9396 7.75 14.9996 9H17.2096C17.1396 7.28 16.0896 5.7 13.9996 5.19V3H10.9996V5.16C10.4696 5.28 9.96957 5.46 9.51957 5.7L10.9896 7.17C11.3996 7 11.8996 6.9 12.4996 6.9ZM5.32957 4.06L4.05957 5.33L7.49957 8.77C7.49957 10.85 9.05957 11.98 11.4096 12.68L14.9196 16.19C14.5796 16.67 13.8696 17.1 12.4996 17.1C10.4396 17.1 9.62957 16.18 9.51957 15H7.31957C7.43957 17.19 9.07957 18.42 10.9996 18.83V21H13.9996V18.85C14.9596 18.67 15.8196 18.3 16.4496 17.73L18.6696 19.95L19.9396 18.68L5.32957 4.06Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33311">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default money_off;
